module.exports = __webpack_public_path__ + "media/images/df-magazine-summer-2023-e4981b95.jpeg";